// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b01de5dd","653":"d279d4c3"}[chunkId] + ".chunk.js";
};